import { ArtistFestivalType } from '@api';
import { DataTableColumn } from 'mantine-datatable';
import { FestivalTableCell } from './components';

export type UseArtistFestivalsColumnsReturnType = {
  columns: DataTableColumn<ArtistFestivalType>[];
};

export const useArtistFestivalsColumns =
  (): UseArtistFestivalsColumnsReturnType => {
    const columns: DataTableColumn<ArtistFestivalType>[] = [
      {
        accessor: 'festival',
        render: (record) => <FestivalTableCell record={record} />,
      },
    ];

    return { columns };
  };
